"use client";

import React from "react";

import { Snackbar } from "@onair/minimal-ui/snackbar";
import { ProgressBar } from "@onair/minimal-ui/progress-bar";

import MainProviders from "./main";

const Providers = ({ children }: { children: React.ReactNode }) => {
	return (
		<MainProviders>
			<Snackbar expand={false} />
			<ProgressBar />
			{children}
		</MainProviders>
	);
};
export default Providers;
